var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarDayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-day",
    "data-name": "Icon awesome-calendar-day",
    d: "M0,28.094A2.9,2.9,0,0,0,2.893,31H24.107A2.9,2.9,0,0,0,27,28.094V11.625H0ZM3.857,16.469a.969.969,0,0,1,.964-.969h5.786a.969.969,0,0,1,.964.969v5.813a.969.969,0,0,1-.964.969H4.821a.969.969,0,0,1-.964-.969ZM24.107,3.875H21.214V.969A.969.969,0,0,0,20.25,0H18.321a.969.969,0,0,0-.964.969V3.875H9.643V.969A.969.969,0,0,0,8.679,0H6.75a.969.969,0,0,0-.964.969V3.875H2.893A2.9,2.9,0,0,0,0,6.781V9.688H27V6.781A2.9,2.9,0,0,0,24.107,3.875Z",
    fill: "#fefefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDayIcon);
export default __webpack_public_path__ + "static/media/CalendarDayIcon.1138966c1a3b3b6537cddd6b830b89bb.svg";
export { ForwardRef as ReactComponent };